import React, { useContext } from "react";
import { CButton } from "@app/components/Common/";
import { TradeRealTimeFilterSection } from "./OrderBook/styles";
import { View } from "@/styles/reactnative";
import { COLORS } from "@app/constants/";
import { ThemeContext } from "@/theme/ThemeProvider";
import OneDefault from '../assets/oneDefault.svg?react'
import TwoBid from '../assets/twoBid.svg?react'
import ThreeAsk from '../assets/threeAsk.svg?react'
import LightDefault from '../assets/LightDefault.svg?react'
import LightAsk from '../assets/LightAsk.svg?react'
import LightBid from '../assets/LightBid.svg?react'
import styled from "styled-components";

const TradeRealTimeFilter = ({
  filterTab,
  setFilterTab,
  grouplist,
  selected,
  setSelected,
}: any) => {
  const { isDarkMode, theme } = useContext(ThemeContext);
  // const lightDefault = IMAGES.lightDefault
  // const lightAsk = IMAGES.lightAsk
  // const lightBid = IMAGES.lightBid
  // const darkDefault = IMAGES.darkDefault
  // const darkAsk = IMAGES.darkAsk
  // const darkBid = IMAGES.darkBid
  const data = [
    { name: "one", image: isDarkMode ? OneDefault : LightDefault },
    { name: "two", image: isDarkMode ? TwoBid : LightBid },
    { name: "three", image: isDarkMode ? ThreeAsk : LightAsk },
  ];

  return (
    <TradeRealTimeFilterSection>
      <View style={{ flexDirection: "row", gap: 5 }}>
        {data.map((item, index) => (
          <IconSVG
            key={index.toString()}
            onClick={() => {
              setFilterTab(item.name);
            }}
            style={{
              background:
                item.name === filterTab
                  ? "transparent"
                  : theme.COLORS.borderColor,
              borderRadius: 0,
              padding: 1,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
            as={item.image}
          />
        ))}
      </View>
      {/* 			
			<NormalDropdown
				title={selected}
				setSelected={setSelected}
				selected={selected}
				data={grouplist}
				style={{
					marginLeft: -50,
				}}
				btnStyle={{
					backgroundColor: COLORS.gray,
					paddingBlock: 2,
					marginTop: 5,
				}}
			/> */}
    </TradeRealTimeFilterSection>
  );
};

export default React.memo(TradeRealTimeFilter);

const IconSVG = styled.svg`
    cursor: pointer;
`

const darkDefault = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#8F8F8F" />
    <path d="M2.5 2H7V9H2.5V2Z" fill="#F71053" />
    <path d="M9 2H16.5V5H9V2Z" fill="#D4D4D4" />
    <path d="M9 6H16.5V9H9V6Z" fill="#D4D4D4" />
    <path d="M9 10H16.5V13H9V10Z" fill="#D4D4D4" />
    <path d="M9 14H16.5V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 10H7V17H2.5V10Z" fill="#37A16A" />
  </svg>
);

const lightDefault = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#B7B7B7" />
    <path d="M2.5 2H7V9H2.5V2Z" fill="#F71053" />
    <path d="M9 2H16.5V5H9V2Z" fill="#D4D4D4" />
    <path d="M9 6H16.5V9H9V6Z" fill="#D4D4D4" />
    <path d="M9 10H16.5V13H9V10Z" fill="#D4D4D4" />
    <path d="M9 14H16.5V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 10H7V17H2.5V10Z" fill="#37A16A" />
  </svg>
);

const darkBid = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#8F8F8F" />
    <path d="M2.5 2L7 2L7 9H2.5L2.5 2Z" fill="#F71053" />
    <path d="M9 2L16.5 2V5L9 5V2Z" fill="#D4D4D4" />
    <path d="M9 6L16.5 6V9L9 9V6Z" fill="#D4D4D4" />
    <path d="M9 10L16.5 10V13L9 13V10Z" fill="#D4D4D4" />
    <path d="M9 14L16.5 14V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 2L7 2L7 17H2.5L2.5 2Z" fill="#37A16A" />
  </svg>
);

const lightBid = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#B7B7B7" />
    <path d="M2.5 2L7 2L7 9H2.5L2.5 2Z" fill="#F71053" />
    <path d="M9 2L16.5 2V5L9 5V2Z" fill="#D4D4D4" />
    <path d="M9 6L16.5 6V9L9 9V6Z" fill="#D4D4D4" />
    <path d="M9 10L16.5 10V13L9 13V10Z" fill="#D4D4D4" />
    <path d="M9 14L16.5 14V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 2L7 2L7 17H2.5L2.5 2Z" fill="#37A16A" />
  </svg>
);

const darkAsk = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#8F8F8F" />
    <path d="M2.5 2L7 2L7 9H2.5L2.5 2Z" fill="#F71053" />
    <path d="M9 2L16.5 2V5L9 5V2Z" fill="#D4D4D4" />
    <path d="M9 6L16.5 6V9L9 9V6Z" fill="#D4D4D4" />
    <path d="M9 10L16.5 10V13L9 13V10Z" fill="#D4D4D4" />
    <path d="M9 14L16.5 14V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 2L7 2L7 17H2.5L2.5 2Z" fill="#F71053" />
  </svg>
);

const lightAsk = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="18" height="18" stroke="#B7B7B7" />
    <path d="M2.5 2L7 2L7 9H2.5L2.5 2Z" fill="#F71053" />
    <path d="M9 2L16.5 2V5L9 5V2Z" fill="#D4D4D4" />
    <path d="M9 6L16.5 6V9L9 9V6Z" fill="#D4D4D4" />
    <path d="M9 10L16.5 10V13L9 13V10Z" fill="#D4D4D4" />
    <path d="M9 14L16.5 14V17H9V14Z" fill="#D4D4D4" />
    <path d="M2.5 2L7 2L7 17H2.5L2.5 2Z" fill="#F71053" />
  </svg>
);
